import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_8: FaireProductEntity = {
  token: "atc_updated_moma_8",
  type: "product",
  name: "Patterned Porcelain Mug Collection",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a9d6fe817244c5e2a616b212d7a516cfcd49a3180e8b94b4a01df31c9ba69c9f.webp",
  priceDollars: 28,
  msrpDollars: 34,
  description: "Teardrop and polka dot designs.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
